
'use strict';

var $ = require('jquery');

var stickyheaderRedwing = {
    init: function () {
        var $menu = $('.js-menu-header-bar');
        var $secondary = $('.js-pdp-header-bar');
        var $wrapper = $('.js-global-header-wrapper');
        var $mainContent = $('#maincontent').first(); // Get the main content container
        var $trigger = $('.st-product-detail__prices').first();
        var hasSecondary = $secondary.length;
        var hasTrigger = $trigger.length;
        var lastScrollTop = 0;
        var isSecondaryVisible = false;
        var menuInitialOffset = $menu.offset().top;
        var initialMarginTop = $mainContent.length ? parseInt($mainContent.css('margin-top'), 10)-menuInitialOffset : 0;

        function updatePositions() {
            var menuHeight = $menu.outerHeight();
            var isMenuHidden = $menu.hasClass('hidden');
            if (hasSecondary) {
                $secondary.css('top', isMenuHidden ? '0' : menuHeight + 'px');
            }

            var currentScroll = $(window).scrollTop();
            var shouldBeSticky = currentScroll >= menuInitialOffset;

            $wrapper.toggleClass('is-sticky', shouldBeSticky || isSecondaryVisible);

            // Adjust main content margin when header becomes sticky
            if ($mainContent.length) {
                if (shouldBeSticky) {
                    $mainContent.css('margin-top', (menuHeight + menuInitialOffset) + 'px');
                    $wrapper.css('margin-bottom', '-' + menuHeight + 'px');
                } else {
                    $mainContent.css('margin-top', initialMarginTop + 'px');
                    $wrapper.css('margin-bottom', '');
                }
            }
        }

        function handleScroll() {
            var currentScroll = $(window).scrollTop();
            var menuHeight = $menu.outerHeight();
            var isMenuHidden = $menu.hasClass('hidden');

            if (hasTrigger) {
                var triggerTop = $trigger.offset().top;
                var triggerBottom = triggerTop + $trigger.outerHeight();
                var menuBase = isMenuHidden ? 0 : menuHeight;
                var shouldBeVisible = triggerTop <= (currentScroll + menuBase);
                if (isSecondaryVisible && !shouldBeVisible) {
                    var viewportBottom = currentScroll + window.innerHeight;
                    shouldBeVisible = triggerTop > currentScroll && triggerBottom < viewportBottom;
                    shouldBeVisible = !shouldBeVisible;
                }
                if (shouldBeVisible !== isSecondaryVisible && hasSecondary) {
                    $secondary.toggleClass('hidden', !shouldBeVisible).toggleClass('visible', shouldBeVisible);
                    isSecondaryVisible = shouldBeVisible;
                }
            }

            if (currentScroll < lastScrollTop) {
                $menu.removeClass('hidden');
            }

            updatePositions();

            lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
        }

        if (hasSecondary) {
            $secondary.on('click', function() {
                $('html, body').animate({ scrollTop: 0 }, 500);
            });
        }

        $(window).on('scroll', handleScroll);
        $(window).on('resize', function() {
            menuInitialOffset = $menu.offset().top;
            updatePositions();
        });
        $(window).on('load', updatePositions);

        updatePositions();
    }
};

module.exports = stickyheaderRedwing;
